import { IPage, ISearchPage } from '@/types/AppTypes'
import { httpRequest } from '@/utils/HttpRequest'

//详情
export interface IAlcoholDrivingDetail {
    id?: string
    prefix?: string
    shopId?: string
    shopCode?: string
    shopName?: string
    branch?: string
    ver?: string
    enable?: string
    orgCode?: string
    orgName?: string
    contact?: string
    phone?: string
    address?: string
    status?: number | boolean
    sourceApp?: string
    categoryName?: string
    typeCode?: string
    typeName?: string
    suffixNum?: number
    settingType?: string
    isYear?: number
    isMonth?: number
    isDate?: number
    style?: string
    note?: string
    orderNum?: number
    traceId?: string
    deleteFlag?: number
    createTime?: string
    updateTime?: string
    createUser?: string
    updateUser?: string
    [key: string]: any
}
//新增
export interface IAlcoholDrivingInsert {
    prefix?: string // "ad reprehenderit magna in",
    suffixNum?: number // 22,
    settingType?: string // "CALCULATE",
    isYear?: number // 55,
    isMonth?: number // 59,
    isDate?: number // 20180911,
    note?: string // "veniam sint laborum tempor",
    style?: string // "incididunt"
}

//编辑
export interface IAlcoholDrivingUpdate extends IAlcoholDrivingInsert {
    id?: string
}
//搜索条件
export interface IAlcoholDrivingSearchFields {
    startTime?: string
    endTime?: string
    [key: string]: any
}

export interface IAlcoholDrivingSearch extends IAlcoholDrivingSearchFields, ISearchPage {
    shopId?: string
    shopCode?: string
}

export interface IpositionSearch extends IAlcoholDrivingSearchFields, ISearchPage {}

class AlcoholDrivingService {
    async page(searchVo: IAlcoholDrivingSearch, config: object = {}) {
        const apiUrl = '/threeInspection/scheduling/alcohol/list'
        return await httpRequest.post<IPage<any>>(apiUrl, searchVo, config)
    }
    async insert(searchVo: IAlcoholDrivingSearchFields) {
        const apiUrl = '/threeInspection/alcoholDriving/insert'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async edit(searchVo: IAlcoholDrivingSearchFields) {
        const apiUrl = '/threeInspection/alcoholDriving/update'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async onDelete(searchVo: IAlcoholDrivingSearchFields) {
        const apiUrl = '/threeInspection/alcoholDriving/delete'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async sendNotifications(searchVo: IAlcoholDrivingSearchFields) {
        const apiUrl = '/threeInspection/alcoholDriving/notice'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async one(searchVo: IAlcoholDrivingSearchFields) {
        const apiUrl = '/threeInspection/ciOrder/page'
        return await httpRequest.post<IPage<IAlcoholDrivingDetail>>(apiUrl, searchVo)
    }
    async orderLogs(searchVo: IAlcoholDrivingSearchFields) {
        const apiUrl = '/threeInspection/ciOrder/progress_log/list'
        return await httpRequest.post<any>(apiUrl, searchVo)
    }
    async getAlcoholDrivingImg(updateVo: IAlcoholDrivingUpdate) {
        const apiUrl = '/threeInspection/ciOrder/list_for_group'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async getImageClassifyList(updateVo: IAlcoholDrivingUpdate) {
        const apiUrl = '/threeInspection/ciOrder/list_for_group'
        return await httpRequest.post<boolean>(apiUrl, updateVo)
    }
    async getTotal(shopCode: any) {
        const apiUrl = `/threeInspection/ciOrder/accountStatic/${shopCode}`
        return await httpRequest.get<any>(apiUrl)
    }
    async openDriver(id: any) {
        const apiUrl = `/threeInspection/scheduling/alcohol/open/${id}`
        return await httpRequest.get<any>(apiUrl)
    }
    async openEscortDriver(id: any) {
        const apiUrl = `/threeInspection/scheduling/alcohol/escortOpen/${id}`
        return await httpRequest.get<any>(apiUrl)
    }
    //导出
    async export(searchVo: any) {
        const appPageUrl = '/threeInspection/ciOrder/pageDetails/export'
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 })
    }

    //导出酒精检测列表数据
    async exportList(searchVo: any) {
        const appPageUrl = '/threeInspection/alcohol/export'
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 })
    }
}

export const alcoholDrivingService = new AlcoholDrivingService()
